import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {DashboardContainer} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class ClaimHdrDashboardService extends BaseApiTemplateService<DashboardContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'documents/login-entity-ep/dashboard';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'documents/login-entity-ep/dashboard';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'documents/login-entity-ep/dashboard';
    this.httpClient = http;
  }

  // dashboardDateRange, claimant_entity_hdr_guid
}


